import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface GradientProps {
  initialColor: string;
  finalColor: string;
}

interface UniqueProps {
  unique?: boolean;
}

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  z-index: 0;
`;

export const FragmentCardBottomToTop = styled.div<GradientProps>`
  cursor: pointer;
  margin-top: -154px;
  height: 202px;
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1);
  background-image: ${(props: GradientProps) => `linear-gradient(123deg, ${props.initialColor}, ${props.finalColor})`};
`;

export const FirstFragmentCardBottomToTop = styled.div<GradientProps>`
  cursor: pointer;
  height: 202px;
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1);
  background-image: ${(props: GradientProps) => `linear-gradient(123deg, ${props.initialColor}, ${props.finalColor})`};
`;

export const FragmentAllianceCardBottomToTop = styled.div<UniqueProps>`
  cursor: pointer;
  margin-top: ${({ unique }) => (unique ? '0' : '-154px')};
`;

export const InnerTitleBottomToTop = styled.div`
  margin-left: 28px;
  padding-top: 16px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.White};
`;
